window.tinymce.PluginManager.add('upload_image', function(editor) {
    editor.addButton('upload_image', function() {
        function showDialog() {
            editor.windowManager.open(
                {
                    title: 'Upload Image',
                    width: 600,
                    height: 215,
                    file: window.hashed_paths['tinymce_upload_image.html'],
                },
            );
        }

        return {
            tooltip: 'Upload Image',
            onclick: showDialog,
            icon: 'custom fa-cloud-upload',
        };
    });
});
